import { useContext } from 'react';

import { QuestionChangeInformationContext } from './question-change-information-provider';

function useQuestionChangeInformation() {
  const context = useContext(QuestionChangeInformationContext);

  if (!context) {
    throw new Error(
      'useQuestionChangeInformation must be used within a QuestionChangeInformationProvider',
    );
  }

  return context;
}

export { useQuestionChangeInformation };
